<script lang="ts">
export default {
  name: "BasePagination",
};
</script>

<script setup lang="ts">
import { PaginatedCollection } from "@/services/fobizzToolsApi";

export type Props = {
  paginatedItems: PaginatedCollection;
};

const { t } = useI18n();
const route = useRoute();
const props = defineProps<Props>();
const firstItem = computed(() => props.paginatedItems.offsetValue + 1);
const lastItem = computed(
  () =>
    props.paginatedItems.offsetValue + props.paginatedItems.collection.length
);
const showPagination = computed(() => {
  if (props.paginatedItems.totalPages > 1) {
    return true;
  }

  if (
    props.paginatedItems.totalPages === 1 &&
    props.paginatedItems.currentPage !== 1
  ) {
    return true;
  }

  return false;
});
</script>

<template>
  <nav
    v-if="showPagination"
    class="d-flex justify-content-end py-3 px-1"
    role="navigation"
    aria-label="Pagination Navigation"
  >
    <div class="pagination-row ms-auto">
      <span class="font-xs me-3">
        {{
          t("labels.itemTotals", {
            firstItem: firstItem,
            lastItem: lastItem,
            totalCount: paginatedItems.totalCount,
          })
        }}
      </span>

      <router-link
        v-if="paginatedItems.currentPage > 1"
        rel="prev"
        class="btn btn-light btn-sm prev"
        :aria-label="t('buttons.previous')"
        :to="{
          query: {
            ...route.query,
            page: paginatedItems.currentPage - 1,
          },
        }"
      >
        <i class="bi bi-chevron-left"></i>
      </router-link>

      <router-link
        v-if="paginatedItems.currentPage < paginatedItems.totalPages"
        rel="next"
        class="btn btn-light btn-sm next"
        :aria-label="t('buttons.next')"
        :to="{
          query: {
            ...route.query,
            page: paginatedItems.currentPage + 1,
          },
        }"
      >
        <i class="bi bi-chevron-right"></i>
      </router-link>
    </div>
  </nav>
</template>

<style scoped lang="scss">
.pagination-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: $spacer-2;

  .pagination {
    display: flex;

    > span {
      margin-right: $spacer-2;
    }
  }

  &--centered {
    justify-content: center;
  }
}
</style>
